import MuiAlert from "@mui/material/Alert";
import type { AlertProps } from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import type { SnackbarProps } from "@mui/material/Snackbar";

type Props = {
  open: boolean;
  onClose?: SnackbarProps["onClose"];
  autoHideDuration?: SnackbarProps["autoHideDuration"];
} & AlertProps;

const Alert = ({
  open,
  onClose,
  autoHideDuration,
  children,
  ...alertProps
}: Props) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={
        autoHideDuration === undefined ? 6000 : autoHideDuration
      }
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={onClose}
      sx={{
        width: "auto",
        maxWidth: { xs: "calc(100vw - 32px)", sm: "25vw" },
      }}
    >
      <MuiAlert
        elevation={4}
        onClose={onClose}
        sx={{
          alignItems: "flex-start",
          maxWidth: "inherit",
          "& .MuiAlert-message": {
            overflowWrap: "anywhere",
            whiteSpace: "pre-line",
          },
        }}
        {...alertProps}
      >
        {children}
      </MuiAlert>
    </Snackbar>
  );
};

export default Alert;
